import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidebarState {
    collapsed: boolean;
    hoverCollapsed?: boolean;
    isDesktop: boolean;
}

const initialState: SidebarState = {
    collapsed: false, // o true, según tu preferencia inicial
    hoverCollapsed: false,
    isDesktop: true,
};


export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setCollapsed: (state, action: PayloadAction<boolean>) => {
            state.collapsed = action.payload;
        },
        toggleCollapsed: (state) => {
            state.collapsed = !state.collapsed;
        },
        setHoverCollapsed: (state, action: PayloadAction<boolean>) => {
            state.hoverCollapsed = action.payload;
        },
        setIsDesktop: (state, action: PayloadAction<boolean>) => {
            state.isDesktop = action.payload;
        }
    }
});


export const { setCollapsed, toggleCollapsed, setHoverCollapsed, setIsDesktop } = sidebarSlice.actions;
export default sidebarSlice.reducer;
